module.exports = __webpack_public_path__ + "static/pesce200_1-825ba718e26fdfeb4b9132fd9c8e6e3f.png";